import { motion } from "framer-motion";
import { Droplet, Sparkles, Disc, Settings, CircleDot, Cpu, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "zamena-ulja",
    title: "Zamena Ulja & Filteri",
    desc: "Brza zamena motornog ulja renomiranih proizvođača, filtera goriva, vazduha i kabine uz proveru nivoa svih tečnosti.",
    icon: Droplet,
    tag: "Redovno Održavanje",
  },
  {
    id: "autoperionica-detailing",
    title: "Auto Pranje & Detailing",
    desc: "Dubinsko pranje enterijera, poliranje farova i karoserije, nanošenje keramičke zaštite za vrhunski sjaj.",
    icon: Sparkles,
    tag: "Nega Vozila",
  },
  {
    id: "abs-kocnice",
    title: "ABS & Kočioni Sistem",
    desc: "Kompletna dijagnostika i zamena kočionih diskova, pločica, kočionih creva i zamena tečnosti u kočnicama.",
    icon: Disc,
    tag: "Bezbednost",
  },
  {
    id: "transmisija-menjac",
    title: "Servis Menjača & Kvačila",
    desc: "Reparacija manuelnih i automatskih menjača, zamena seta kvačila, plivajućeg zamajca i ulja u menjaču.",
    icon: Settings,
    tag: "Mehanika",
  },
  {
    id: "vulkanizer-gume",
    title: "Vulkanizer & Gume",
    desc: "Montaža i balansiranje guma, popravka bušnih pneumatika i kompjutersko centriranje trapa.",
    icon: CircleDot,
    tag: "Pneumatici",
  },
  {
    id: "motorni-tuning-dijagnostika",
    title: "Dijagnostika & Motor",
    desc: "Najsavremenija kompjuterska dijagnostika kvarova, kompresija motora, zamena zupčastog kaiša i veliki servisi.",
    icon: Cpu,
    tag: "Dijagnostika",
  },
];

export default function Services() {
  return (
    <section id="usluge" className="relative py-24 lg:py-32 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14"
        >
          <div>
            <span className="text-red-500 text-xs font-bold tracking-[0.3em] uppercase">Šta nudimo</span>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-none">
              Naše <span className="text-red-500">Usluge</span>
            </h2>
          </div>
          <p className="text-zinc-500 max-w-sm text-sm leading-relaxed">
            Od redovnog održavanja do kompleksnih popravki — sve na jednom mestu, sa garancijom na svaki rad.
          </p>
        </motion.div>

        <div data-testid="services-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <motion.a
              key={s.id}
              href="#kontakt"
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: "easeOut" }}
              whileHover={{ y: -6 }}
              className="group relative bg-[#121216] border border-white/[0.07] rounded-2xl p-7 overflow-hidden transition-colors hover:border-red-600/40 hover:shadow-[0_8px_40px_rgba(227,22,30,0.15)]"
            >
              <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-red-600/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-xl bg-red-600/12 border border-red-600/25 flex items-center justify-center text-red-500 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <s.icon size={22} strokeWidth={1.8} />
                </div>
                <ArrowUpRight size={18} className="text-zinc-600 group-hover:text-red-500 transition-colors" />
              </div>
              <h3 className="font-display text-2xl tracking-wide text-white mt-6">{s.title}</h3>
              <p className="text-sm text-zinc-500 leading-relaxed mt-3">{s.desc}</p>
              <span className="inline-block mt-5 text-[11px] font-semibold tracking-[0.18em] uppercase text-red-400/80 bg-red-600/10 border border-red-600/20 px-3 py-1 rounded-full">
                {s.tag}
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
